import { graphql } from "@/lib/gql/__generated__";

export const DISCOUNT_LONG_TERM_FOR_LONG_TERM_STAY_UPDATE_MUTATION = graphql(/* GraphQL */ `
	mutation discountLongTermForEditLongTermStayUpdate($input: DiscountLongTermInput!) {
		discountLongTermUpdate(input: $input) {
			userErrors
		}
	}
`);
